export default __webpack_public_path__ + "static/media/Giants.fe75937e.jpg";